<template>
  <div class="base-section sm cardPayment">
    <div class="container content col">
      <div class="row">
        <div class="col s12 l8 center-on-small-only">
          <h1 
            class="success mb-4 font-semibold text-[22px]"
            v-html="$t('cardPayment.title', { siteName: confMain.siteName })"
          ></h1>
          <br>
          <h3 
            class="success mb-4 font-semibold text-[18px]"
            v-html="$t('cardPayment.subTitle')"
          ></h3>

          <h4
            class="red-text"
            v-html="$t('cardPayment.subTitle2', { holdingName: confMain.holdingName })"
          ></h4>
        </div>
        <div class="col hide-on-med-and-down l4">
          <nuxt-picture
            loading="lazy"
            :img-attrs="{class: '', alt: ''}"
            src="/img/authorize-secured.png"
            sizes=""
          />
        </div>
      </div>

      <div class="iframe-loader">
        <iframe
          v-if="paymentLink"
          id="authorize"
          :src="paymentLink"
        ></iframe>
      </div>

      <div
        class="instructions"
        v-html="convertToHtml($t('cardPayment.instructions', { email: 'accounting@ipmedia.net', holdingName: confMain.holdingName }))"
      ></div>
    </div>
  </div>
</template>

<script setup>
const { confMain } = useConfig()
const paymentLink = ref(false)
const { href } = useRoute()

if (href.split('ipaymenturl=') && href.split('ipaymenturl=')[1]) {
  paymentLink.value = decodeURIComponent(href.split('ipaymenturl=')[1])
}
</script>

<style lang="scss" scoped>
.iframe-loader {
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 300px;
  text-align: center;
  #authorize {
    z-index: 0;
    overflow-y: scroll;
    width: 1000px;
    height: 500px;
    margin: auto;
    border: none;
  }
}
</style>
